module.exports = __webpack_public_path__ + "static/media/kitchen-diningAreaWindow.1d068f81.png";